import type { Order } from '@barboxx/models/types';

import { api } from '../../api';
import { throwIfBadResponse } from '../../utils';

const rootPath = `orders/customer`;

// Generated by Copilot
export type QuoteCustomerOrderRequest = Order.QuoteRequest;
export type QuoteCustomerOrderResponse = Order.QuoteResponse;
export type CheckoutCustomerOrderPayload = Order.CheckoutPayload;

export function quoteCustomerOrder(data: QuoteCustomerOrderRequest) {
    return throwIfBadResponse(
        api.post<Order.QuoteResponse>(`${rootPath}/quote`, data)
    );
}

export function checkoutCustomerOrder(
    orderId: number,
    data: CheckoutCustomerOrderPayload
) {
    return throwIfBadResponse(
        api.post<Order.CreateResponse>(`${rootPath}/${orderId}/checkout`, data)
    );
}

export function cancelCustomerOrder(
    orderId: number,
    data: Order.CustomerCancelRequest = {}
) {
    return throwIfBadResponse<Order.CustomerCancelResponse, unknown>(
        api.post(`${rootPath}/${orderId}/cancel`, data)
    );
}

export function getCustomerActiveOrders() {
    return api.get<Order[]>(`${rootPath}/active`);
}

export function getCustomerOrders(query?: Order.SearchQuery) {
    return api.get<Order.SearchResponse>(`${rootPath}`, query);
}

export function getCustomerOrder(id: number) {
    return api.get<Order.DetailsResponse>(`${rootPath}/${id}`);
}

export function pickupCustomerOrder(id: number, data: Order.PickupRequest) {
    // Legacy endpoint kept for compatibility with older clients.
    return api.post(`${rootPath}/${id}/pickup`, data);
}

export function confirmCustomerOrderPickupWithNfc(
    id: number,
    data: Order.NfcPickupConfirmRequest
) {
    // Step 1: validate NFC tag and receive short-lived pickup proof token.
    return throwIfBadResponse<Order.NfcPickupConfirmResponse, unknown>(
        api.post(`${rootPath}/${id}/pickup/nfc/confirm`, data),
        'Unable to confirm NFC pickup. Please scan again.'
    );
}

export function verifyCustomerOrderPickupWithSelfie(
    id: number,
    data: Order.NfcPickupVerifyRequest
) {
    // Step 2: consume pickup token, optionally validate selfie, then open cubby.
    return throwIfBadResponse<Order, unknown>(
        api.post(`${rootPath}/${id}/pickup/nfc/verify-selfie`, data, {
            timeout: 120000,
        }),
        'Unable to verify pickup selfie. Please try again.'
    );
}
